(function () {
  'use strict';

  var KEY = 'snv_wishlist';

  var SNVWishlist = {
    getAll: function () {
      try { return JSON.parse(localStorage.getItem(KEY)) || []; }
      catch (e) { return []; }
    },
    has: function (handle) {
      return this.getAll().indexOf(handle) > -1;
    },
    add: function (handle) {
      var list = this.getAll();
      if (list.indexOf(handle) === -1) {
        list.push(handle);
        localStorage.setItem(KEY, JSON.stringify(list));
        this._fire(list);
      }
    },
    remove: function (handle) {
      var list = this.getAll().filter(function (h) { return h !== handle; });
      localStorage.setItem(KEY, JSON.stringify(list));
      this._fire(list);
    },
    toggle: function (handle) {
      if (this.has(handle)) { this.remove(handle); return false; }
      this.add(handle); return true;
    },
    count: function () { return this.getAll().length; },
    _fire: function (list) {
      document.dispatchEvent(new CustomEvent('snv:wishlist:change', { detail: { list: list } }));
    }
  };

  /* ── Badge update ── */
  function updateBadges() {
    var n = SNVWishlist.count();
    document.querySelectorAll('.snv-wl-count').forEach(function (el) {
      el.style.display = n > 0 ? 'flex' : 'none';
      var span = el.querySelector('span[aria-hidden]');
      if (span) span.textContent = n < 100 ? n : '99+';
    });
  }

  /* ── Sync single button state ── */
  function syncBtn(btn) {
    var active = SNVWishlist.has(btn.dataset.handle);
    btn.classList.toggle('snv-wl-active', active);
    btn.setAttribute('aria-label', active ? 'Elimină din wishlist' : 'Adaugă în wishlist');
  }

  /* ── Init all buttons on page ── */
  function initBtns() {
    document.querySelectorAll('.snv-wl-btn[data-handle]').forEach(function (btn) {
      syncBtn(btn);
      if (btn.dataset.snvBound) return;
      btn.dataset.snvBound = '1';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        SNVWishlist.toggle(btn.dataset.handle);
        syncBtn(btn);
        btn.classList.add('snv-wl-pop');
        setTimeout(function () { btn.classList.remove('snv-wl-pop'); }, 350);
      });
    });
  }

  document.addEventListener('snv:wishlist:change', function () {
    updateBadges();
    initBtns();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initBtns(); updateBadges(); });
  } else {
    initBtns();
    updateBadges();
  }

  window.SNVWishlist = SNVWishlist;
})();
